<template>
  <div id="app">
    <component :is="$route.meta.layout || 'my-page-layout'">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
import MyPageLayout from '@/layouts/MyPageLayout.vue'
export default {
  components: { MyPageLayout },
  computed: {
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
  },
  created() {
    window.addEventListener('pagehide', this.handler, { once: true })
  },
  beforeCreate() {
    const tmpCarts = JSON.parse(localStorage.getItem(this.Constants.LOCAL_CART))

    if (tmpCarts) {
      this.$store.commit('cart/SET_CART', tmpCarts.carts)
      this.$store.commit('cart/SET_SUBSCRIPTION', tmpCarts.subscription)
      this.$store.commit('cart/SET_SUBSCRIPTION_CARTS_SUMMARY', tmpCarts.subscriptionCartsSummary)
      this.$store.commit('cart/SET_NOMAL_CARTS_SUMMARY', tmpCarts.normalCartsSummary)
    }
  },
  methods: {
    handler() {
      localStorage.setItem(
        this.Constants.LOCAL_CART,
        JSON.stringify({
          subscription: this.$store.state.cart.subscription,
          carts: this.$store.state.cart.carts,
          normalCartsSummary: this.$store.state.cart.normalCartsSummary,
          subscriptionCartsSummary: this.$store.state.cart.subscriptionCartsSummary,
        })
      )
    },
  },
}
</script>
